import { getStore } from '~/mobx/AppStore';

export const getIsLoading = (): boolean => {
    const candidateStore = getStore().candidateStore;

    return (
        candidateStore.isLoadingCandidateList ||
        candidateStore.isDeletingCandidate ||
        candidateStore.isCreatingCandidate ||
        candidateStore.isUpdatingCandidate ||
        candidateStore.isLoadingCandidateAttributesOptions ||
        candidateStore.isCopyingCandidate
    );
};
